import React from "react";
import { createSignalRContext } from "react-signalr/signalr";
import { connect } from "react-redux";
import { signalRContants } from "../../../constants/signalr.constants";
import {
  adminActions,
  authActions,
  subscriptionActions,
} from "../../../redux/actions";

// Create the SignalR context
const SignalRContext = createSignalRContext();
const { LOGOUT, LOAD_NOTIFICATIONS, UPDATE_SUBSCRIPTION } = signalRContants;

const SignalRListener = ({
  userRole,
  getSubscriptions,
  getAdminNotifications,
  getUserSubscriptionStatus,
  logout,
}) => {
  SignalRContext.useSignalREffect(LOGOUT, () => {
    logout();
  });

  SignalRContext.useSignalREffect(LOAD_NOTIFICATIONS, () => {
    getAdminNotifications();
  });

  SignalRContext.useSignalREffect(UPDATE_SUBSCRIPTION, () => {
    getUserSubscriptionStatus(userRole, false, false);
    getSubscriptions(userRole, false);
  });

  return null; // This component does not need to render anything
};

const SignalRWrapper = ({
  token,
  children,
  userRole,
  getSubscriptions,
  getAdminNotifications,
  getUserSubscriptionStatus,
  logout,
}) => {
  return (
    <SignalRContext.Provider
      connectEnabled={!!token}
      accessTokenFactory={() => token}
      dependencies={[token]} // Reconnect if the token changes
      url={process.env.REACT_APP_SIGNALR_URL}
    >
      <SignalRListener
        userRole={userRole}
        getSubscriptions={getSubscriptions}
        getAdminNotifications={getAdminNotifications}
        getUserSubscriptionStatus={getUserSubscriptionStatus}
        logout={logout}
      />
      {children}
    </SignalRContext.Provider>
  );
};

const mapStateToProps = (state) => ({
  userRole: state.authReducer.userRole,
});

const mapDispatchToProps = (dispatch) => ({
  getAdminNotifications: () => dispatch(adminActions.getAdminNotifications()),
  getUserSubscriptionStatus: (roleId, isNavigateToDefault, isSpinnerEnabled) =>
    dispatch(
      subscriptionActions.getUserSubscriptionStatus(
        roleId,
        isNavigateToDefault,
        isSpinnerEnabled
      )
    ),
  getSubscriptions: (roleId, isSpinnerEnabled) =>
    dispatch(subscriptionActions.getSubscriptions(roleId, isSpinnerEnabled)),
  logout: () => dispatch(authActions.logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignalRWrapper);
